import React from 'react'
import styled from 'styled-components'
import { media } from 'Styles/style-utils'
import { getText } from 'Utils/translatedText'

const ViewContainer = styled.div`
	padding-top: 220px;
	margin: 0 auto;
	background: black;
	width: 100%;
	height: 100%;
	padding-top: 160px;

	.inner {
		width: ${(props) => props.theme.desktophd.col12};
		margin: 0 auto;

		${media.tablet`
      width: ${(props) => props.theme.tablet.col8};
    `};
		${media.mobile`
      width: ${(props) => props.theme.mobile.col5};
    `};
	}
`

const BodyContainer = styled.div`
	text-align: center;
	padding: 0;
	padding-bottom: 2rem;
	width: ${(props) => props.theme.desktophd.col12};
	h1 {
		text-align: center;
		color: white;
	}
	.iframe-wrapper {
		width: 100%;
		aspect-ratio: 5 / 3;
		${media.tablet`
   		aspect-ratio: 3 / 4;
    `};

		text-align: left;
		margin: 0 auto;
		iframe {
			width: 100%;
			height: 100%;
		}
		a {
			color: ${(props) => props.theme.colors.pink};
		}
	}
`

const Title = styled.h1`
	${(props) => props.theme.responsiveType.pageTitle};
	margin-bottom: 2rem !important;
`

const InteractiveModel = (props) => {
	return (
		<ViewContainer>
			<div className="inner">
				<BodyContainer>
					<Title>{getText('links.3dPussy', props.language)}</Title>
					<div className="iframe-wrapper">
						<iframe
							title="Interactive Model"
							id="embedded-human"
							frameBorder="0"
							width="600"
							height="450"
							allowFullScreen={true}
							src="https://human.biodigital.com/widget/?be=2wO0&background.colors=1,0.949,0.949&ui-info=true&ui-fullscreen=false&ui-zoom=true&ui-share=false&load-rotate=90&initial.button=true&camera=35.645,70.237,-152.572,0.014,122.374,-6.627,0.112,0.891,-0.439&uaid=M4Tyc"
						/>
					</div>
				</BodyContainer>
			</div>
		</ViewContainer>
	)
}

export default InteractiveModel
